import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import SurveyList from '../components/SurveyList/SurveyList';
import Title from '../components/Title/Title';
import MainContainer from '../components/MainContainer';
import StudyIntro from '../components/StudyIntro/StudyIntro';
import useFetchStudy from '../hooks/useFetchStudy';
import LoadingWrapper from '../components/LoadingWrapper';
import LoadingIndicator from '../components/LoadingIndicator';

const SurveyListPage = () => {
  type ParamTypes = {
    studyid: string;
  };
  const { t } = useTranslation();
  const { studyid } = useParams<ParamTypes>();
  const { study, loading, error } = useFetchStudy(studyid);

  return (
    <MainContainer>
      <LoadingWrapper
        isLoading={loading}
        isInErrorState={error != null}
        errorMsg={t('study_intro_loading_error')}
        loadingComponent={
          <Container>
            <LoadingIndicator />
          </Container>
        }
      >
        <StudyIntro study={study} />
      </LoadingWrapper>

      <Title>{t('surveys')}</Title>
      <SurveyList />
    </MainContainer>
  );
};

export default SurveyListPage;
